<template>
  <div class="warm-range">
    <div class="second-title">
      {{ title }}
    </div>
    <el-form ref="warmRef" :model="localChecked">
      <div class="warm-container">
        <warm
          :value="localChecked.coldStorage"
          :type="'coldStorage'"
          :disabled="disabled"
          @change="val => handleCheck(val,'coldStorage')"
        />
        <warm
          :value="localChecked.freezing"
          :type="'freezing'"
          :disabled="disabled"
          @change="val => handleCheck(val,'freezing')"
        />
      </div>
    </el-form>
  </div>
</template>

<script>
import warm from './warm.vue';

const defaultChecked = {
  edit: true,
  coldStorage: [
  ],
  freezing: [
  ],
};
export default {
  components: { warm },
  props: {
    title: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: Object,
      default: () => defaultChecked,
    },
  },
  data() {
    return {
      localChecked: {},
    };
  },
  watch: {
    checked: {
      handler(val) {
        this.localChecked = val;
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleCheck(val, prop) {
      this.localChecked[prop] = val;
      this.$emit('handleCheck', this.localChecked);
    },
    validate(callback) {
      return this.$refs.warmRef.validate(callback);
    },
  },
};
</script>

<style lang="scss" scoped>
.warm-range{
  margin-bottom: 30px;
  .second-title{
    margin-bottom:8px;
  }
  .warm-container{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
}
</style>
